import { createIcon } from "app/icons/createIcon";
import _AlertCircleFilledIcon from "./AlertCircleFilledIcon";
import _ArrowDownIcon from "./ArrowDownIcon";
import _ArrowDownwardIcon from "./ArrowDownwardIcon";
import _ArrowLeftCircleFilledIcon from "./ArrowLeftCircleFilledIcon";
import _ArrowLeftCircleStrokeIcon from "./ArrowLeftCircleStrokeIcon";
import _ArrowLeftIcon from "./ArrowLeftIcon";
import _ArrowRightCircleFilledIcon from "./ArrowRightCircleFilledIcon";
import _ArrowRightCircleStrokeIcon from "./ArrowRightCircleStrokeIcon";
import _ArrowRightIcon from "./ArrowRightIcon";
import _ArrowUpIcon from "./ArrowUpIcon";
import _ArrowUpRightIcon from "./ArrowUpRightIcon";
import _BarsFilterIcon from "./BarsFilterIcon";
import _CalendarFilledIcon from "./CalendarFilledIcon";
import _CalendarStrokeIcon from "./CalendarStrokeIcon";
import _CheckIcon from "./CheckIcon";
import _CheckmarkCircleFilledIcon from "./CheckmarkCircleFilledIcon";
import _CheckmarkCircleStrokeIcon from "./CheckmarkCircleStrokeIcon";
import _CheckmarkSquareFilledIcon from "./CheckmarkSquareFilledIcon";
import _CheckmarkSquareStrokeIcon from "./CheckmarkSquareStrokeIcon";
import _ClockFilledIcon from "./ClockFilledIcon";
import _ClockStrokeIcon from "./ClockStrokeIcon";
import _CopyContentIcon from "./CopyContentIcon";
import _CrossCircleFilledIcon from "./CrossCircleFilledIcon";
import _CrossCircleStrokeIcon from "./CrossCircleStrokeIcon";
import _CrossIcon from "./CrossIcon";
import _DeleteFilledIcon from "./DeleteFilledIcon";
import _DeleteStrokeIcon from "./DeleteStrokeIcon";
import _DownloadIcon from "./DownloadIcon";
import _EyeFilledIcon from "./EyeFilledIcon";
import _EyeOffFilledIcon from "./EyeOffFilledIcon";
import _EyeOffStrokeIcon from "./EyeOffStrokeIcon";
import _EyeStrokeIcon from "./EyeStrokeIcon";
import _FilterFilledIcon from "./FilterFilledIcon";
import _FilterStrokeIcon from "./FilterStrokeIcon";
import _FireFilledIcon from "./FireFilledIcon";
import _FireStrokeIcon from "./FireStrokeIcon";
import _HeartFilledIcon from "./HeartFilledIcon";
import _HeartStrokeIcon from "./HeartStrokeIcon";
import _HelpCircleFilledIcon from "./HelpCircleFilledIcon";
import _HelpCircleStrokeIcon from "./HelpCircleStrokeIcon";
import _HistoryIcon from "./HistoryIcon";
import _HomeFilledIcon from "./HomeFilledIcon";
import _HomeStrokeIcon from "./HomeStrokeIcon";
import _HorizontalFilterFilledIcon from "./HorizontalFilterFilledIcon";
import _HorizontalFilterStrokeIcon from "./HorizontalFilterStrokeIcon";
import _ImportExportIcon from "./ImportExportIcon";
import _InfoCircleFilledIcon from "./InfoCircleFilledIcon";
import _InfoCircleStrokeIcon from "./InfoCircleStrokeIcon";
import _LessCircleFilledIcon from "./LessCircleFilledIcon";
import _LessCircleStrokeIcon from "./LessCircleStrokeIcon";
import _LessIcon from "./LessIcon";
import _LinkSquareIcon from "./LinkSquareIcon";
import _ListViewIcon from "./ListViewIcon";
import _MenuIcon from "./MenuIcon";
import _MoreCircleFilledIcon from "./MoreCircleFilledIcon";
import _MoreCircleStrokeIcon from "./MoreCircleStrokeIcon";
import _MoreHorizontalIcon from "./MoreHorizontalIcon";
import _MoreIcon from "./MoreIcon";
import _NotificationFilledIcon from "./NotificationFilledIcon";
import _NotificationStrokeIcon from "./NotificationStrokeIcon";
import _OpenInNewIcon from "./OpenInNewIcon";
import _PauseFilledIcon from "./PauseFilledIcon";
import _PauseStrokeIcon from "./PauseStrokeIcon";
import _PenFilledIcon from "./PenFilledIcon";
import _PenStrokeIcon from "./PenStrokeIcon";
import _PhotoFilledIcon from "./PhotoFilledIcon";
import _PhotoStrokeIcon from "./PhotoStrokeIcon";
import _PlayFilledIcon from "./PlayFilledIcon";
import _PlayStrokeIcon from "./PlayStrokeIcon";
import _PuceIcon from "./PuceIcon";
import _RefreshIcon from "./RefreshIcon";
import _ReloadIcon from "./ReloadIcon";
import _SearchIcon from "./SearchIcon";
import _ShareFilledIcon from "./ShareFilledIcon";
import _ShareStrokeIcon from "./ShareStrokeIcon";
import _SquareLockFilledIcon from "./SquareLockFilledIcon";
import _SquareLockStrokeIcon from "./SquareLockStrokeIcon";
import _SquareUnlockFilledIcon from "./SquareUnlockFilledIcon";
import _SquareUnlockStrokeIcon from "./SquareUnlockStrokeIcon";
import _ThumbsUpFilledIcon from "./ThumbsUpFilledIcon";
import _ThumbsUpStrokeIcon from "./ThumbsUpStrokeIcon";
import _TradeDownIcon from "./TradeDownIcon";
import _TransferFilledIcon from "./TransferFilledIcon";
import _TransferStrokeIcon from "./TransferStrokeIcon";
import _WarningFilledIcon from "./WarningFilledIcon";
import _WarningStrokeIcon from "./WarningStrokeIcon";

export const AlertCircleFilledIcon = createIcon(_AlertCircleFilledIcon);
export const ArrowDownIcon = createIcon(_ArrowDownIcon);
export const ArrowDownwardIcon = createIcon(_ArrowDownwardIcon);
export const ArrowLeftCircleFilledIcon = createIcon(_ArrowLeftCircleFilledIcon);
export const ArrowLeftCircleStrokeIcon = createIcon(_ArrowLeftCircleStrokeIcon);
export const ArrowLeftIcon = createIcon(_ArrowLeftIcon);
export const ArrowRightCircleFilledIcon = createIcon(_ArrowRightCircleFilledIcon);
export const ArrowRightCircleStrokeIcon = createIcon(_ArrowRightCircleStrokeIcon);
export const ArrowRightIcon = createIcon(_ArrowRightIcon);
export const ArrowUpIcon = createIcon(_ArrowUpIcon);
export const ArrowUpRightIcon = createIcon(_ArrowUpRightIcon);
export const BarsFilterIcon = createIcon(_BarsFilterIcon);
export const CalendarFilledIcon = createIcon(_CalendarFilledIcon);
export const CalendarStrokeIcon = createIcon(_CalendarStrokeIcon);
export const CheckIcon = createIcon(_CheckIcon);
export const CheckmarkCircleFilledIcon = createIcon(_CheckmarkCircleFilledIcon);
export const CheckmarkCircleStrokeIcon = createIcon(_CheckmarkCircleStrokeIcon);
export const CheckmarkSquareFilledIcon = createIcon(_CheckmarkSquareFilledIcon);
export const CheckmarkSquareStrokeIcon = createIcon(_CheckmarkSquareStrokeIcon);
export { ChevronDown } from "./ChevronDown";
export const ClockFilledIcon = createIcon(_ClockFilledIcon);
export const ClockStrokeIcon = createIcon(_ClockStrokeIcon);
export const CopyContentIcon = createIcon(_CopyContentIcon);
export const CrossCircleFilledIcon = createIcon(_CrossCircleFilledIcon);
export const CrossCircleStrokeIcon = createIcon(_CrossCircleStrokeIcon);
export const CrossIcon = createIcon(_CrossIcon);
export const DeleteFilledIcon = createIcon(_DeleteFilledIcon);
export const DeleteStrokeIcon = createIcon(_DeleteStrokeIcon);
export const DownloadIcon = createIcon(_DownloadIcon);
export const EyeFilledIcon = createIcon(_EyeFilledIcon);
export const EyeOffFilledIcon = createIcon(_EyeOffFilledIcon);
export const EyeOffStrokeIcon = createIcon(_EyeOffStrokeIcon);
export const EyeStrokeIcon = createIcon(_EyeStrokeIcon);
export const FilterFilledIcon = createIcon(_FilterFilledIcon);
export const FilterStrokeIcon = createIcon(_FilterStrokeIcon);
export const FireFilledIcon = createIcon(_FireFilledIcon);
export const FireStrokeIcon = createIcon(_FireStrokeIcon);
export const HeartFilledIcon = createIcon(_HeartFilledIcon);
export const HeartStrokeIcon = createIcon(_HeartStrokeIcon);
export const HelpCircleFilledIcon = createIcon(_HelpCircleFilledIcon);
export const HelpCircleStrokeIcon = createIcon(_HelpCircleStrokeIcon);
export const HistoryIcon = createIcon(_HistoryIcon);
export const HomeFilledIcon = createIcon(_HomeFilledIcon);
export const HomeStrokeIcon = createIcon(_HomeStrokeIcon);
export const HorizontalFilterFilledIcon = createIcon(_HorizontalFilterFilledIcon);
export const HorizontalFilterStrokeIcon = createIcon(_HorizontalFilterStrokeIcon);
export const ImportExportIcon = createIcon(_ImportExportIcon);
export const InfoCircleFilledIcon = createIcon(_InfoCircleFilledIcon);
export const InfoCircleStrokeIcon = createIcon(_InfoCircleStrokeIcon);
export const LessCircleFilledIcon = createIcon(_LessCircleFilledIcon);
export const LessCircleStrokeIcon = createIcon(_LessCircleStrokeIcon);
export const LessIcon = createIcon(_LessIcon);
export const LinkSquareIcon = createIcon(_LinkSquareIcon);
export const ListViewIcon = createIcon(_ListViewIcon);
export const MenuIcon = createIcon(_MenuIcon);
export const MoreCircleFilledIcon = createIcon(_MoreCircleFilledIcon);
export const MoreCircleStrokeIcon = createIcon(_MoreCircleStrokeIcon);
export const MoreHorizontalIcon = createIcon(_MoreHorizontalIcon);
export const MoreIcon = createIcon(_MoreIcon);
export const NotificationFilledIcon = createIcon(_NotificationFilledIcon);
export const NotificationStrokeIcon = createIcon(_NotificationStrokeIcon);
export const OpenInNewIcon = createIcon(_OpenInNewIcon);
export const PauseFilledIcon = createIcon(_PauseFilledIcon);
export const PauseStrokeIcon = createIcon(_PauseStrokeIcon);
export const PenFilledIcon = createIcon(_PenFilledIcon);
export const PenStrokeIcon = createIcon(_PenStrokeIcon);
export const PhotoFilledIcon = createIcon(_PhotoFilledIcon);
export const PhotoStrokeIcon = createIcon(_PhotoStrokeIcon);
export const PlayFilledIcon = createIcon(_PlayFilledIcon);
export const PlayStrokeIcon = createIcon(_PlayStrokeIcon);
export const PuceIcon = createIcon(_PuceIcon);
export const RefreshIcon = createIcon(_RefreshIcon);
export const ReloadIcon = createIcon(_ReloadIcon);
export const SearchIcon = createIcon(_SearchIcon);
export const ShareFilledIcon = createIcon(_ShareFilledIcon);
export const ShareStrokeIcon = createIcon(_ShareStrokeIcon);
export const SquareLockFilledIcon = createIcon(_SquareLockFilledIcon);
export const SquareLockStrokeIcon = createIcon(_SquareLockStrokeIcon);
export const SquareUnlockFilledIcon = createIcon(_SquareUnlockFilledIcon);
export const SquareUnlockStrokeIcon = createIcon(_SquareUnlockStrokeIcon);
export const ThumbsUpFilledIcon = createIcon(_ThumbsUpFilledIcon);
export const ThumbsUpStrokeIcon = createIcon(_ThumbsUpStrokeIcon);
export const TradeDownIcon = createIcon(_TradeDownIcon);
export const TransferFilledIcon = createIcon(_TransferFilledIcon);
export const TransferStrokeIcon = createIcon(_TransferStrokeIcon);
export const WarningFilledIcon = createIcon(_WarningFilledIcon);
export const WarningStrokeIcon = createIcon(_WarningStrokeIcon);
